module.exports = __webpack_public_path__ + "img/s4-bg.e92c43da.jpg";